module.exports = __webpack_public_path__ + "img/article-gb-dwrg-1.c406e0fc.jpg";